import Axios from 'axios';
import { GlobalStats } from './types';

export function getGlobalStats(): Promise<GlobalStats> {
  return Axios.get<GlobalStats>(
    `${process.env.REACT_APP_STATS_HOST}/admin/data/global_stats.json`
  ).then(resp => {
    return resp.data;
  });
}
